import { Switch } from '@mui/material';
import styled from 'styled-components';

import { TToggleContainer } from '@/shared/components/ui/form/components/toggle/toggle.types';

/** Renders as a label when the text is safe to click, so it toggles the switch too. */
export const ToggleContainer = styled.label<TToggleContainer>`
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

export const StyledSwitch = styled(Switch)`
  && {
    width: 2.25rem;
    height: 1.25rem;
    padding: 0;
    position: relative;
    border-radius: 0.75rem;
    margin: -1px !important;

    /* The base must keep sizing itself around the thumb: it is what stretches
       the hidden input across the whole pill, and so the whole pill's hit area. */
    & .MuiSwitch-switchBase {
      padding: 0.125rem;

      &.Mui-checked {
        transform: translateX(1rem);

        & + .MuiSwitch-track {
          background-color: ${({ theme }) => theme.palette.primary.main};
        }
      }
    }

    & .MuiSwitch-track {
      opacity: 1 !important;
      background-color: ${({ theme }) => theme.palette.primary.light};
    }

    & .MuiSwitch-thumb {
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      color: ${({ theme }) => theme.palette.primary.contrastText};
      box-shadow: none;
      filter: drop-shadow(
          0px 3px 6px ${({ theme }) => theme.palette.common.black}0D
        )
        drop-shadow(0px 2px 4px ${({ theme }) => theme.palette.common.black}0D)
        drop-shadow(0px 1px 2px ${({ theme }) => theme.palette.common.black}0D)
        drop-shadow(0px 1px 0px ${({ theme }) => theme.palette.common.black}0D);
    }

    /* Matches the checked selector's specificity, so disabled wins by order. */
    & .MuiSwitch-switchBase.Mui-disabled {
      & + .MuiSwitch-track {
        background-color: ${({ theme }) => theme.palette.background.default};
      }

      & .MuiSwitch-thumb {
        color: ${({ theme }) => theme.palette.stroke.primary};
        filter: none;
        border: none;
      }
    }
  }
`;
